module.exports = __webpack_public_path__ + "static/media/MileMarkerLunch.32dc05a0.pdf";